import {
  GetEmail,
  getEmail,
  delPages,
  DelPages,
  getAttachments,
  GetAttachments,
  GetPhishingPages,
  getPhishingPages,
  getGood,
  GetGood,
  CreateTemplate,
  createTemplate,
  delEmail,
  DelEmail,
  getDetail,
  GetDetail,
  putEmail,
  PutEmail,
  createPhishTemplate,
  CreatePhishTemplate,
  delPhishEmail,
  DelPhishEmail,
  GetPhishDetail,
  getPhishDetail,
  PutPhishEmail,
  putPhishEmail,
  createAttachmentDetail,
  delAttachmentDetail,
  DelAttachmentDetail,
  GetAttachmentDetail,
  getAttachmentDetail,
  PutAttachmentName,
  putAttachmentName,
  getAttachmentsDownload,
  GetAttachmentsDownload,
  CloneHtml,
  cloneHtml,
  getEducationTemplateList,
  GetEducationTemplateList,
  getEmailAttck,
  getAttachmentAttck,
  getPhishAttck,
} from '@/api/template'
import { checkAvailableStatus } from '@/api/fishing-task'
import { Message } from '@/components/message'
import { useRequest } from 'ahooks'
import { message } from 'antd'
//  获取所有邮件模板
interface GetEmailProps {
  GetEmailParams: GetEmail
}
export const useGetEmail = (props: GetEmailProps) => {
  const { GetEmailParams } = props
  const { run, data } = useRequest(() => getEmail(GetEmailParams), {
    refreshDeps: [GetEmailParams],
    onError(err: any) {
      Message.error(err?.msg || '获取模板列表失败')
    },
  })
  return [run, data?.data || []] as const
}

export const useGetEmailAttck = () => {
  const { data } = useRequest(() => getEmailAttck(), {
    // manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取ATT&CK列表失败')
    },
  })

  return [data?.data?.items || []] as const
}
// //  获取所有邮件模板
// export const useGetTemplates = () => {
//     const { runAsync: run } = useRequest((data: GetTemplates) => getTemplates(data), {
//         manual: true,
//         onError(err: any) {
//             Message.error(err?.msg || '获取邮件模板失败')
//         },
//     })

//     return [run] as const
// }
//  删除自定义模板
export const useDelPages = () => {
  const { runAsync: run } = useRequest((data: DelPages) => delPages(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '删除自定义模板失败')
    },
  })

  return [run] as const
}
//  获取所有钓鱼模板
interface GetPhishingProps {
  GetPhishingParams: GetPhishingPages
}
export const useGetPhishingPages = (props: GetPhishingProps) => {
  const { GetPhishingParams } = props
  const { run, data } = useRequest(() => getPhishingPages(GetPhishingParams), {
    refreshDeps: [GetPhishingParams],
    onError(err: any) {
      Message.error(err?.msg || '获取模板列表失败')
    },
  })
  return [run, data?.data || []] as const
}
export const useGetPhishAttck = () => {
  const { data } = useRequest(() => getPhishAttck(), {
    // manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取ATT&CK列表失败')
    },
  })

  return [data?.data?.items || []] as const
}

//  附件模板
interface GetAttachmentsProps {
  GetAttachmentsParams: GetAttachments
}
export const useGetAttachments = (props: GetAttachmentsProps) => {
  const { GetAttachmentsParams } = props
  const { run, data } = useRequest(() => getAttachments(GetAttachmentsParams), {
    refreshDeps: [GetAttachmentsParams],
    onError(err: any) {
      Message.error(err?.msg || '获取模板列表失败')
    },
  })
  return [run, data?.data || []] as const
}
//  最佳匹配
export const useGetGood = () => {
  const { runAsync: run, data } = useRequest((datas: GetGood) => getGood(datas), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取最佳搭配失败')
    },
  })

  return [run, data?.data || []] as const
}
export const useGetAttachmentAttck = () => {
  const { data } = useRequest(() => getAttachmentAttck(), {
    // manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取ATT&CK列表失败')
    },
  })

  return [data?.data?.items || []] as const
}
//  添加自定义模板
export const useCreateTemplate = () => {
  const { runAsync: run } = useRequest((data: CreateTemplate) => createTemplate(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '添加自定义邮件模板失败')
    },
  })

  return [run] as const
}
//  删除自定义模板
export const useDelEmail = () => {
  const { runAsync: run, loading } = useRequest((data: DelEmail) => delEmail(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '删除自定义邮件模板失败')
    },
  })

  return [run, loading] as const
}
//  获取自定义模板详情
export const useGetDetail = () => {
  const { runAsync: run, loading } = useRequest((data: GetDetail) => getDetail(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取自定义邮件模板详情失败')
    },
  })

  return [run, loading] as const
}
//  修改自定义模板详情
export const usePutEmail = () => {
  const { runAsync: run, loading } = useRequest((data: PutEmail) => putEmail(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '修改自定义邮件模板详情失败')
    },
  })

  return [run, loading] as const
}
//  添加自定义钓鱼模板
export const useCreatePhishTemplate = () => {
  const { runAsync: run } = useRequest((data: CreatePhishTemplate) => createPhishTemplate(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '添加自定义钓鱼模板失败')
    },
  })

  return [run] as const
}
//  删除自定义钓鱼模板
export const useDelPhishEmail = () => {
  const { runAsync: run, loading } = useRequest((data: DelPhishEmail) => delPhishEmail(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '删除自定义钓鱼模板失败')
    },
  })

  return [run, loading] as const
}
//  获取自定义钓鱼模板详情
export const useGetPhishDetail = () => {
  const { runAsync: run, loading } = useRequest((data: GetPhishDetail) => getPhishDetail(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取自定义钓鱼模板详情失败')
    },
  })

  return [run, loading] as const
}
//  修改自定义钓鱼模板详情
export const usePutPhishEmail = () => {
  const { runAsync: run, loading } = useRequest((data: PutPhishEmail) => putPhishEmail(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '修改自定义钓鱼模板详情失败')
    },
  })

  return [run, loading] as const
}
//  添加自定义附件模板详情
export const useCreateAttachmentDetail = () => {
  const { runAsync: run, loading } = useRequest(data => createAttachmentDetail(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '添加自定义附件模板详情失败')
    },
  })

  return [run, loading] as const
}

//  删除自定义附件模板
export const useDelAttachmentDetail = () => {
  const { runAsync: run, loading } = useRequest(
    (data: DelAttachmentDetail) => delAttachmentDetail(data),
    {
      manual: true,
      onError(err: any) {
        Message.error(err?.msg || '删除自定义附件模板失败')
      },
    },
  )

  return [run, loading] as const
}
// //  获取自定义附件模板详情
export const useGetAttachmentDetail = () => {
  const { runAsync: run, loading } = useRequest(
    (data: GetAttachmentDetail) => getAttachmentDetail(data),
    {
      manual: true,
      onError(err: any) {
        Message.error(err?.msg || '获取自定义附件模板详情失败')
      },
    },
  )

  return [run, loading] as const
}
//  附件下载
export const useGetAttachmentsDownload = () => {
  const { runAsync: run, loading } = useRequest(
    (data: GetAttachmentsDownload) => getAttachmentsDownload(data),
    {
      manual: true,
      onError(err: any) {},
    },
  )

  return [run, loading] as const
}
//  修改自定义钓鱼模板详情
export const usePutAttachmentName = () => {
  const { runAsync: run, loading } = useRequest(
    (data: PutAttachmentName) => putAttachmentName(data),
    {
      manual: true,
      onError(err: any) {
        Message.error(err?.msg || '修改自定义附件模板详情失败')
      },
    },
  )

  return [run, loading] as const
}
//  克隆页面
export const useCloneHtml = () => {
  const { runAsync: run, loading } = useRequest((data: CloneHtml) => cloneHtml(data), {
    manual: true,
    onError(err: any) {
      // Message.error(err?.msg || '修改自定义附件模板详情失败')
    },
  })

  return [run, loading] as const
}

export const useGetEducationTemplateList = () => {
  const {
    data,
    runAsync: run,
    loading,
  } = useRequest((param: GetEducationTemplateList) => getEducationTemplateList(param), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取安全教育模板列表失败')
    },
  })

  return [data?.data || {}, run, loading] as const
}

export const useCheckAvailableStatus = () => {
  const { data } = useRequest(() => checkAvailableStatus(), {
    manual: false,
    onError(err: any) {
      Message.error(err?.msg || '获取AI接口可用状态失败')
    },
  })
  return [data?.data || []] as const
}
